type FormatRelativeTimeOptions = { justNowSeconds?: number };

const MINUTE_SECONDS = 60;
const HOUR_SECONDS = 60 * MINUTE_SECONDS;
const DAY_SECONDS = 24 * HOUR_SECONDS;
const MONTH_SECONDS = 30 * DAY_SECONDS;
const YEAR_SECONDS = 365 * DAY_SECONDS;

const pluralize = (value: number, unit: string): string => (value === 1 ? unit : `${unit}s`);

export const formatRelativeTime = (
  value: Date | string | null | undefined,
  options?: FormatRelativeTimeOptions,
): string => {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.valueOf())) return '';

  const secondsDiff = Math.floor((Date.now() - date.getTime()) / 1000);
  const justNowSeconds = options?.justNowSeconds ?? 10;
  if (secondsDiff < justNowSeconds) return 'Just now';
  if (secondsDiff < MINUTE_SECONDS) {
    return `${secondsDiff} ${pluralize(secondsDiff, 'second')} ago`;
  }
  if (secondsDiff < HOUR_SECONDS) {
    const minutes = Math.floor(secondsDiff / MINUTE_SECONDS);
    return `${minutes} ${pluralize(minutes, 'minute')} ago`;
  }
  if (secondsDiff < DAY_SECONDS) {
    const hours = Math.floor(secondsDiff / HOUR_SECONDS);
    return `${hours} ${pluralize(hours, 'hour')} ago`;
  }
  if (secondsDiff < MONTH_SECONDS) {
    const days = Math.floor(secondsDiff / DAY_SECONDS);
    return `${days} ${pluralize(days, 'day')} ago`;
  }
  if (secondsDiff < YEAR_SECONDS) {
    const months = Math.floor(secondsDiff / MONTH_SECONDS);
    return `${months} ${pluralize(months, 'month')} ago`;
  }
  const years = Math.floor(secondsDiff / YEAR_SECONDS);
  return `${years} ${pluralize(years, 'year')} ago`;
};
